export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-random/src/defaultSource.js
// module id = 27
// module chunks = 0